export default "__VITE_ASSET__BnU$xxUW__"